/**
 * @fileoverview POST handler for the "/apps/:app_id/push_credential_test" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdPushCredentialTestCacheKeys } from "./constants";
import type { AppsAppIdPushCredentialTestResult, PostAppsAppIdPushCredentialTestProps } from "./types";

export const postAppsAppIdPushCredentialTest = reactQueryMutationAdapter(
  appsAppIdPushCredentialTestCacheKeys,
  (props: PostAppsAppIdPushCredentialTestProps): Promise<AppsAppIdPushCredentialTestResult> => {
    return fetch(`/apps/${props.appId}/push_credential_test`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
